import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';


export default class ArticleHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {country, locale} = this.props;
    const {content} = this.props.articleInfo;
    const headerContent = content.desc;
    const fontChange = country === 'vn' && locale === 'vi_VN' ? 'vnFont' : country === 'jp' && locale === 'ja_JP'? 'jpFont': ''
    let innerHtml
    if(headerContent !== ""){
      innerHtml =  getHTMLElement(headerContent, {useHTML: true });
    }
    else{
      innerHtml = "";
    }
    return(
          <div id= "articleHeaderContainer" className= {`articleHeaderContainer ${fontChange}`} >
            <section><div>{innerHtml}</div></section>
          </div>

    );
  }
}

ArticleHeader.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      header: PropTypes.string
    })
  })
};
